import React, { FC } from 'react';
import { Wrapper } from 'components/theme/Wrapper';
import {
  ResourceHeading2,
  ResourceParagraph,
} from 'components/theme/Typography/ResourceTypography';
import { useTranslation } from 'react-i18next';
import {
  Header,
  LayoutWrapper,
  Main,
} from 'features/GuestReschedule/components/Layout';
import ReservationItemList from 'features/GuestReschedule/components/ReservationItemList';
import { PrimaryButton } from 'components/theme/Button';
import { useHistory } from 'react-router-dom';
import useInitGuestReschedule from 'features/GuestReschedule/hooks/useInitGuestReschedule';
import useGuestReschedule from 'features/GuestReschedule/hooks/useGuestReschedule';
import NoBookingsAvailable from 'features/GuestReschedule/components/NoBookingsAvailable';
import { ReservationItemListSkeleton } from 'features/GuestReschedule/components/ReservationItemListSkeleton';

const GuestReschedulePage: FC = () => {
  const { t } = useTranslation();
  const history = useHistory();

  useInitGuestReschedule();

  const { selectedBookingId, cartId, bookings, token, isLoading } =
    useGuestReschedule();

  // If there are multiple bookings, we don't show the reschedule policy notes
  const notes = bookings.length > 1 ? null : bookings[0]?.reschedulePolicyNotes;

  const handleContinue = () =>
    history.push({
      pathname: `/carts/${cartId}/guest-reschedule/booking/${selectedBookingId}/date`,
      search: `?token=${token}`,
    });

  if (!bookings.length && !isLoading) {
    return <NoBookingsAvailable title={t('selectAReservationToReschedule')} />;
  }

  return (
    <Wrapper>
      <LayoutWrapper>
        <Header>
          <ResourceHeading2 fontSize="28px" className="title">
            {t('selectAReservationToReschedule')}
          </ResourceHeading2>
          {notes && (
            <ResourceParagraph
              className="subtitle"
              fontSize="16px"
              opacity="0.7"
              fontWeight="400"
              lineHeight="20px"
            >
              {notes}
            </ResourceParagraph>
          )}
        </Header>
        <Main>
          {isLoading ? (
            <ReservationItemListSkeleton />
          ) : (
            <ReservationItemList />
          )}
        </Main>
        <PrimaryButton
          big
          disabled={!selectedBookingId}
          onClick={handleContinue}
        >
          {t('continue')}
        </PrimaryButton>
      </LayoutWrapper>
    </Wrapper>
  );
};

export default GuestReschedulePage;
